import theme from '../../../lib/theme';
import { InputProps } from './Input';

const {
  corners,
  inputReset,
  scale,
  colors,
  font: { families },
} = theme;

export default ({ type = 'text', status, border = 'grey' }: InputProps) => ({
  container: {
    ...inputReset,

    backgroundColor: colors.white,
    outline: 'none',
    border:
      type !== 'file'
        ? `1px solid ${status ? colors[status] : colors[border]}`
        : 'none',
    borderRadius: corners.m,
    fontFamily: families.primary,
    color: colors.dark_grey,
    padding: type !== 'file' ? `${scale.xs} ${scale.s}` : 0,
    width: '100%',
    minHeight: type === 'file' ? 'auto' : 50,
    height: type === 'textarea' || type === 'file' ? 'auto' : 50,

    '&:focus': {
      borderColor: colors.focus,
    },
  },
});
